import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import { phoneformatter } from "../../core/transforms";
class CustomersPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Customer",
      state: "customer",
      name: "user",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Email", name: "email", isSortable: true },
      { title: "Phone", name: "phone" },
      { title: "Active", name: "active" },
      { title: "Role", name: "role" },
    ];

    this.addOptions = {
      title: "Add New Customer",
      icon: "add",
      fields: [
        {
          name: "name",
          title: "Customer name",
          type: "name",
          isText: true,
          isRequired: true,
        },
        {
          name: "email",
          title: "Customer email",
          type: "email",
          isText: true,
          isRequired: true,
        },
        {
          name: "phone",
          title: "Customer phone",
          type: "text",
          isText: true,
          isRequired: true,
          formatter: phoneformatter,
        },
      ],
    };

    this.filters = [
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "User",
        state: "customer",
        size: 30,
        hasExact: true,
        exactFields: ["email", "phone"],
      },
    ];
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);

    return map(getSource)(data);
  }
}

export default CustomersPageTransform;



// WEBPACK FOOTER //
// ./src/pages/customers/customers.transforms.js